import React from 'react';
import { Link, useLocation } from 'react-router';
import { connect } from 'react-redux';
import { ListItem, ListItemIcon, ListItemText, SvgIcon, Tooltip } from '@mui/material';
import Nbsp from '../../../util/Nbsp';

const VIEW_BOX = '0 -2 30 30';

const STYLES_ACTIVE = {
  background: `#ff2828`,
  borderRadius: '0 10px 10px 0',
  margin: '0 1em 0 0',
};

const STYLES_INACTIVE = {
  borderRadius: '0 10px 10px 0',
  margin: '0 1em 0 0',
};

const DrawerItem = ({
  children,
  text,
  action,
  authLevel,
  icon,
  to = '#',
  isOpen = true,
  userAuthLevel,
}) => {
  const location = useLocation();
  const [, path] = location.pathname.split('/', 2);
  const [, itemLinkPath] = to.split('/', 2);
  const svgClassName = itemLinkPath === path ? 'active' : 'inactive';
  if (authLevel == null || userAuthLevel <= authLevel) {
    return (
      <Link to={to} className="nav-link" onClick={action} style={{ margin: '0', padding: '0' }}>
        <ListItem
          dense
          key={text}
          style={svgClassName === 'active' ? STYLES_ACTIVE : STYLES_INACTIVE}
        >
          <ListItemIcon className="nav-icon">
            <Tooltip title={text}>
              <SvgIcon component={icon} viewBox={VIEW_BOX} className={svgClassName} />
            </Tooltip>
          </ListItemIcon>
          <ListItemText
            className="nav-text"
            style={
              svgClassName === 'active'
                ? { color: 'white', fontWeight: 'bold' }
                : { color: 'black' }
            }
          >
            {isOpen ? text : <Nbsp />}
          </ListItemText>
          {children}
        </ListItem>
      </Link>
    );
  }
  return null;
};

export default connect(({ user: { userAuthLevel } }) => ({ userAuthLevel }))(DrawerItem);
